// Feature flags for controlling new functionality rollout
export const FEATURE_FLAGS = {
  PERSONALIZED_FEED: import.meta.env.VITE_PERSONALIZED_FEED_ENABLED === 'true'
} as const;

// Removed: isPersonalizedFeedEnabled() - no longer needed since feed is enabled by default

// User interface for type safety
interface User {
  id?: string;
  email?: string;
}

// Get current user ID (you may need to adjust this based on your auth system)
export const getCurrentUserId = (): string | null => {
  // This should integrate with your existing auth system
  // For now, we'll try to get it from localStorage or return null
  try {
    const user: User = JSON.parse(localStorage.getItem('user') || '{}');
    return user.id || null;
  } catch {
    return null;
  }
};

// Get current user email (for beta user checks)
export const getCurrentUserEmail = (): string | null => {
  try {
    const user: User = JSON.parse(localStorage.getItem('user') || '{}');
    return user.email || null;
  } catch {
    return null;
  }
};

// Beta users who get early access (you can customize this list)
const BETA_USERS: string[] = [
  // Add email addresses of users who should get early access
  // 'admin@yourapp.com', 'test@yourapp.com'
];

// Check if current user is a beta user
export const isBetaUser = (): boolean => {
  const email = getCurrentUserEmail();
  return email ? BETA_USERS.includes(email) : false;
};

// Enhanced personalized feed check with beta user support
export const isPersonalizedFeedEnabledForUser = (): boolean => {
  // First check if the feature is enabled globally
  if (!FEATURE_FLAGS.PERSONALIZED_FEED) {
    return false;
  }
  
  // Check if user has explicitly opted out
  if (localStorage.getItem('personalizedFeedOptIn') === 'false') {
    return false;
  }
  
  // Default: Personalized feed is ENABLED for all users (guests and registered)
  // Users can opt-out if they prefer the default feed
  return true;
};

// Generate a session ID for better personalization
export const getSessionId = (): string => {
  let sessionId = sessionStorage.getItem('feedSessionId');
  
  if (!sessionId) {
    // Generate a simple session ID
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('feedSessionId', sessionId);
  }
  
  return sessionId;
};

// Debug helper for development
export const debugFeatureFlags = (): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log('[FEATURE FLAGS DEBUG]', {
      PERSONALIZED_FEED: FEATURE_FLAGS.PERSONALIZED_FEED,
      isPersonalizedFeedEnabledForUser: isPersonalizedFeedEnabledForUser(),
      isBetaUser: isBetaUser(),
      currentUserId: getCurrentUserId(),
      currentUserEmail: getCurrentUserEmail(),
      sessionId: getSessionId(),
      optInStatus: localStorage.getItem('personalizedFeedOptIn'),
      defaultEnabled: true
    });
  }
};
